var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-image.j2"] = require( "macros/product-image.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["mto/templates/macros/mto-image.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-image.j2", false, "mto/templates/macros/mto-image.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("productImageSrc")) {
var t_4 = t_1.productImageSrc;
} else {
cb(new Error("cannot import 'productImageSrc'")); return;
}
context.setVariable("productImageSrc", t_4);
if(t_1.hasOwnProperty("lazyPreload")) {
var t_5 = t_1.lazyPreload;
} else {
cb(new Error("cannot import 'lazyPreload'")); return;
}
context.setVariable("lazyPreload", t_5);
output += "\n\n";
var macro_t_6 = runtime.makeMacro(
["imageUrl", "imageSlug"], 
["altImageId", "preset", "imageHeight", "imageWidth", "imageScale", "altText", "class", "disableZoom", "defaultImage", "fit", "lazyImage", "lazyImageWidth", "lazyImageHeight", "lazy", "quality", "supportsPNG"], 
function (l_imageUrl, l_imageSlug, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("imageUrl", l_imageUrl);
frame.set("imageSlug", l_imageSlug);
frame.set("altImageId", kwargs.hasOwnProperty("altImageId") ? kwargs["altImageId"] : null);
frame.set("preset", kwargs.hasOwnProperty("preset") ? kwargs["preset"] : null);
frame.set("imageHeight", kwargs.hasOwnProperty("imageHeight") ? kwargs["imageHeight"] : null);
frame.set("imageWidth", kwargs.hasOwnProperty("imageWidth") ? kwargs["imageWidth"] : null);
frame.set("imageScale", kwargs.hasOwnProperty("imageScale") ? kwargs["imageScale"] : null);
frame.set("altText", kwargs.hasOwnProperty("altText") ? kwargs["altText"] : "");
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
frame.set("disableZoom", kwargs.hasOwnProperty("disableZoom") ? kwargs["disableZoom"] : false);
frame.set("defaultImage", kwargs.hasOwnProperty("defaultImage") ? kwargs["defaultImage"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("fit", kwargs.hasOwnProperty("fit") ? kwargs["fit"] : "&fit=constrain");
frame.set("lazyImage", kwargs.hasOwnProperty("lazyImage") ? kwargs["lazyImage"] : false);
frame.set("lazyImageWidth", kwargs.hasOwnProperty("lazyImageWidth") ? kwargs["lazyImageWidth"] : null);
frame.set("lazyImageHeight", kwargs.hasOwnProperty("lazyImageHeight") ? kwargs["lazyImageHeight"] : null);
frame.set("lazy", kwargs.hasOwnProperty("lazy") ? kwargs["lazy"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("quality", kwargs.hasOwnProperty("quality") ? kwargs["quality"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("supportsPNG", kwargs.hasOwnProperty("supportsPNG") ? kwargs["supportsPNG"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_7 = "";if(runtime.contextOrFrameLookup(context, frame, "preset") && runtime.contextOrFrameLookup(context, frame, "imageHeight") && runtime.contextOrFrameLookup(context, frame, "imageWidth")) {
var t_8;
t_8 = "?" + "" + runtime.contextOrFrameLookup(context, frame, "preset") + "" + "&hei=" + "" + runtime.contextOrFrameLookup(context, frame, "imageHeight") + "" + "&wid=" + "" + runtime.contextOrFrameLookup(context, frame, "imageWidth");
frame.set("sizePreset", t_8, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_8);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_8);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "preset") && runtime.contextOrFrameLookup(context, frame, "imageHeight")) {
var t_9;
t_9 = "?" + "" + runtime.contextOrFrameLookup(context, frame, "preset") + "" + "&hei=" + "" + runtime.contextOrFrameLookup(context, frame, "imageHeight");
frame.set("sizePreset", t_9, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_9);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_9);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "preset") && runtime.contextOrFrameLookup(context, frame, "imageWidth")) {
var t_10;
t_10 = "?" + "" + runtime.contextOrFrameLookup(context, frame, "preset") + "" + "&wid=" + "" + runtime.contextOrFrameLookup(context, frame, "imageWidth");
frame.set("sizePreset", t_10, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_10);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_10);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "preset") && runtime.contextOrFrameLookup(context, frame, "imageScale")) {
var t_11;
t_11 = "?" + "" + runtime.contextOrFrameLookup(context, frame, "preset") + "" + "&scl=" + "" + runtime.contextOrFrameLookup(context, frame, "imageScale");
frame.set("sizePreset", t_11, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_11);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_11);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "preset")) {
var t_12;
t_12 = "?" + "" + runtime.contextOrFrameLookup(context, frame, "preset");
frame.set("sizePreset", t_12, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_12);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_12);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "imageHeight")) {
var t_13;
t_13 = "?hei=" + "" + runtime.contextOrFrameLookup(context, frame, "imageHeight");
frame.set("sizePreset", t_13, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_13);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_13);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "imageWidth")) {
var t_14;
t_14 = "?wid=" + "" + runtime.contextOrFrameLookup(context, frame, "imageWidth");
frame.set("sizePreset", t_14, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_14);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_14);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "imageScale")) {
var t_15;
t_15 = "?scl=" + "" + runtime.contextOrFrameLookup(context, frame, "imageScale");
frame.set("sizePreset", t_15, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_15);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_15);
}
;
}
else {
var t_16;
t_16 = "";
frame.set("sizePreset", t_16, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_16);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_16);
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
var t_17;
t_17 = runtime.contextOrFrameLookup(context, frame, "sizePreset") + "" + "&qlt=" + "" + runtime.contextOrFrameLookup(context, frame, "quality");
frame.set("sizePreset", t_17, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_17);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_17);
}
if(runtime.contextOrFrameLookup(context, frame, "altText") && runtime.contextOrFrameLookup(context, frame, "altText") != "") {
var t_18;
t_18 = runtime.contextOrFrameLookup(context, frame, "altText");
frame.set("imageAltText", t_18, true);
if(frame.topLevel) {
context.setVariable("imageAltText", t_18);
}
if(frame.topLevel) {
context.addExport("imageAltText", t_18);
}
;
}
var t_19;
t_19 = (runtime.contextOrFrameLookup(context, frame, "supportsPNG")?"&fmt=png-alpha":"");
frame.set("format", t_19, true);
if(frame.topLevel) {
context.setVariable("format", t_19);
}
if(frame.topLevel) {
context.addExport("format", t_19);
}
t_7 += "<img\n        ";
if(runtime.contextOrFrameLookup(context, frame, "lazy")) {
t_7 += "data-src=\"";
t_7 += runtime.suppressValue((lineno = 34, colno = 38, runtime.callWrap(t_4, "productImageSrc", context, [l_imageUrl,l_imageSlug])), env.opts.autoescape);
t_7 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "sizePreset"), env.opts.autoescape);
t_7 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fit"), env.opts.autoescape);
t_7 += "\"\n            ";
if(runtime.contextOrFrameLookup(context, frame, "lazyImage")) {
t_7 += "\n                src=\"";
t_7 += runtime.suppressValue((lineno = 36, colno = 33, runtime.callWrap(t_5, "lazyPreload", context, [l_imageUrl,runtime.contextOrFrameLookup(context, frame, "lazyImageWidth"),runtime.contextOrFrameLookup(context, frame, "lazyImageHeight")])), env.opts.autoescape);
t_7 += "\"\n            ";
;
}
;
}
else {
t_7 += "src=\"";
t_7 += runtime.suppressValue((lineno = 39, colno = 33, runtime.callWrap(t_4, "productImageSrc", context, [l_imageUrl,l_imageSlug])), env.opts.autoescape);
t_7 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "sizePreset")), env.opts.autoescape);
t_7 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fit"), env.opts.autoescape);
t_7 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "format"), env.opts.autoescape);
t_7 += "\"";
;
}
t_7 += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "altImageId")) {
t_7 += " data-alt-src=\"";
t_7 += runtime.suppressValue((lineno = 41, colno = 54, runtime.callWrap(t_4, "productImageSrc", context, [l_imageUrl,runtime.contextOrFrameLookup(context, frame, "altImageId")])), env.opts.autoescape);
t_7 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "sizePreset")), env.opts.autoescape);
t_7 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "qlt"), env.opts.autoescape);
t_7 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fit"), env.opts.autoescape);
t_7 += "\"";
;
}
t_7 += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "imageAltText")) {
t_7 += "alt=\"";
t_7 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "imageAltText"), env.opts.autoescape);
t_7 += "\"";
;
}
t_7 += "\n        class=\"";
t_7 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "class"), env.opts.autoescape);
t_7 += " ";
if(runtime.contextOrFrameLookup(context, frame, "lazy")) {
t_7 += " js-lazy ";
;
}
if(!runtime.contextOrFrameLookup(context, frame, "disableZoom")) {
t_7 += " has-zoom js-zoom-product-image";
;
}
t_7 += "\"\n        tabindex=\"-1\"\n        data-qa-mto-image\n    />\n";
;
frame = frame.pop();
return new runtime.SafeString(t_7);
});
context.addExport("mtoImage");
context.setVariable("mtoImage", macro_t_6);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["mto/templates/macros/mto-image.j2"] , dependencies)